import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7073/Campaigns";
	}
	constructConditionClauseText(e, t) {
		let n = this.baseUrl + "/ConstructConditionClauseText";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processConstructConditionClauseText(e)));
	}
	processConstructConditionClauseText(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getSpecialConditionBank(e) {
		let t = this.baseUrl + "/GetSpecialConditionBank";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetSpecialConditionBank(e)));
	}
	processGetSpecialConditionBank(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetSpecialConditions(e, t, n) {
		let r = this.baseUrl + "/StaffGetSpecialConditions?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", t != null && (r += "contractId=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetSpecialConditions(e)));
	}
	processStaffGetSpecialConditions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractSpecialConditionDueDate(e, t) {
		let n = this.baseUrl + "/StaffUpdateContractSpecialConditionDueDate";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateContractSpecialConditionDueDate(e)));
	}
	processStaffUpdateContractSpecialConditionDueDate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractSpecialConditions(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractSpecialConditions?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractSpecialConditions(e)));
	}
	processStaffUpdateContractSpecialConditions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	negotiate(e) {
		let t = this.baseUrl + "/Negotiate";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processNegotiate(e)));
	}
	processNegotiate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSearchForCampaign(e, t, n, r) {
		let i = this.baseUrl + "/StaffSearchForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
		if (i += "searchTerm=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'searchForArchived' must be defined and cannot be null.");
		i += "searchForArchived=" + encodeURIComponent("" + t) + "&", n != null && (i += "continuationToken=" + encodeURIComponent("" + n) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffSearchForCampaign(e)));
	}
	processStaffSearchForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	formsByLocations(e) {
		let t = this.baseUrl + "/FormsByLocations";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processFormsByLocations(e)));
	}
	processFormsByLocations(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	loadForm(e, t, n) {
		let r = this.baseUrl + "/LoadForm?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'formId' must be defined and cannot be null.");
		r += "formId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processLoadForm(e)));
	}
	processLoadForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	saveForm(e, t) {
		let n = this.baseUrl + "/SaveForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSaveForm(e)));
	}
	processSaveForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	sendForm(e, t) {
		let n = this.baseUrl + "/SendForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSendForm(e)));
	}
	processSendForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	submitForm(e, t) {
		let n = this.baseUrl + "/SubmitForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSubmitForm(e)));
	}
	processSubmitForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getUploadedFileLink(e, t) {
		let n = this.baseUrl + "/GetUploadedFileLink?";
		if (e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		n += "filePath=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removeFile(e, t) {
		let n = this.baseUrl + "/RemoveFile";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	addOrUpdateDocument(e, t, n, r, i) {
		let a = this.baseUrl + "/AddOrUpdateDocument?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'documentType' must be defined and cannot be null.");
		a += "documentType=" + encodeURIComponent("" + t) + "&", n != null && (a += "contractId=" + encodeURIComponent("" + n) + "&"), r != null && (a += "filePath=" + encodeURIComponent("" + r) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "POST",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processAddOrUpdateDocument(e)));
	}
	processAddOrUpdateDocument(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	exchangeContract(e, t) {
		let n = this.baseUrl + "/ExchangeContract";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processExchangeContract(e)));
	}
	processExchangeContract(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	performContractAction(e, t) {
		let n = this.baseUrl + "/PerformContractAction";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processPerformContractAction(e)));
	}
	processPerformContractAction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBuyersAgent(e, t) {
		let n = this.baseUrl + "/StaffGetBuyersAgent?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBuyersAgent(e)));
	}
	processStaffGetBuyersAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBuyers(e, t) {
		let n = this.baseUrl + "/StaffGetBuyers?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBuyers(e)));
	}
	processStaffGetBuyers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBuyersSolicitor(e, t) {
		let n = this.baseUrl + "/StaffGetBuyersSolicitor?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBuyersSolicitor(e)));
	}
	processStaffGetBuyersSolicitor(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractDates(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractDates?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractDates(e)));
	}
	processStaffGetContractDates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractDeposits(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractDeposits?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractDeposits(e)));
	}
	processStaffGetContractDeposits(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractEarlyRelease(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractEarlyRelease?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractEarlyRelease(e)));
	}
	processStaffGetContractEarlyRelease(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractSettlement(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractSettlement?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractSettlement(e)));
	}
	processStaffGetContractSettlement(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetSaleInformation(e, t, n) {
		let r = this.baseUrl + "/StaffGetSaleInformation?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetSaleInformation(e)));
	}
	processStaffGetSaleInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffPreviewLinkedDates(e, t, n, r) {
		let i = this.baseUrl + "/StaffPreviewLinkedDates?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffPreviewLinkedDates(e)));
	}
	processStaffPreviewLinkedDates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBuyersAgent(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBuyersAgent?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBuyersAgent(e)));
	}
	processStaffUpdateBuyersAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBuyers(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBuyers?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBuyers(e)));
	}
	processStaffUpdateBuyers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBuyersSolicitor(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBuyersSolicitor?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBuyersSolicitor(e)));
	}
	processStaffUpdateBuyersSolicitor(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractComplianceFields(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractComplianceFields?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractComplianceFields(e)));
	}
	processStaffUpdateContractComplianceFields(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractDates(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractDates?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractDates(e)));
	}
	processStaffUpdateContractDates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractDeposits(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractDeposits?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractDeposits(e)));
	}
	processStaffUpdateContractDeposits(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractEarlyRelease(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateContractEarlyRelease?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractEarlyRelease(e)));
	}
	processStaffUpdateContractEarlyRelease(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractSettlement(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateContractSettlement?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractSettlement(e)));
	}
	processStaffUpdateContractSettlement(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractTermination(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateContractTermination?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractTermination(e)));
	}
	processStaffUpdateContractTermination(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateSaleInformation(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateSaleInformation?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateSaleInformation(e)));
	}
	processStaffUpdateSaleInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	beginCampaign(e, t) {
		let n = this.baseUrl + "/BeginCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processBeginCampaign(e)));
	}
	processBeginCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	completeCampaignStep(e, t) {
		let n = this.baseUrl + "/CompleteCampaignStep";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCompleteCampaignStep(e)));
	}
	processCompleteCampaignStep(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	devCreateContractTestCampaign(e, t) {
		let n = this.baseUrl + "/DevCreateContractTestCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processDevCreateContractTestCampaign(e)));
	}
	processDevCreateContractTestCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getActiveCampaigns(e) {
		let t = this.baseUrl + "/GetActiveCampaigns";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetActiveCampaigns(e)));
	}
	processGetActiveCampaigns(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getArchivedCampaignsByAgency(e) {
		let t = this.baseUrl + "/GetArchivedCampaignsByAgency";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetArchivedCampaignsByAgency(e)));
	}
	processGetArchivedCampaignsByAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCampaign(e, t) {
		let n = this.baseUrl + "/GetCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCampaign(e)));
	}
	processGetCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	performCampaignAction(e, t) {
		let n = this.baseUrl + "/PerformCampaignAction";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processPerformCampaignAction(e)));
	}
	processPerformCampaignAction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removeFormSubmission(e, t) {
		let n = this.baseUrl + "/RemoveFormSubmission";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemoveFormSubmission(e)));
	}
	processRemoveFormSubmission(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getArchivedCampaignsByAdmin(e, t) {
		let n = this.baseUrl + "/GetArchivedCampaignsByAdmin?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetArchivedCampaignsByAdmin(e)));
	}
	processGetArchivedCampaignsByAdmin(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCampaignsForAgency(e, t) {
		let n = this.baseUrl + "/GetCampaignsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCampaignsForAgency(e)));
	}
	processGetCampaignsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setCampaignOwnership(e, t) {
		let n = this.baseUrl + "/SetCampaignOwnership";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetCampaignOwnership(e)));
	}
	processSetCampaignOwnership(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffBeginCampaign(e, t) {
		let n = this.baseUrl + "/StaffBeginCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffBeginCampaign(e)));
	}
	processStaffBeginCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetCampaign(e)));
	}
	processStaffGetCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCampaignDashboard(e, t, n, r, i, a, o, s, c, l) {
		let u = this.baseUrl + "/StaffGetCampaignDashboard?";
		e != null && e && e.forEach((e) => {
			u += "agencyIds=" + encodeURIComponent("" + e) + "&";
		}), t != null && t && t.forEach((e) => {
			u += "campaignStatuses=" + encodeURIComponent("" + e) + "&";
		}), n != null && n && n.forEach((e) => {
			u += "launchDateStatuses=" + encodeURIComponent("" + e) + "&";
		}), r != null && r && r.forEach((e) => {
			u += "marketingStatuses=" + encodeURIComponent("" + e) + "&";
		}), i != null && i && i.forEach((e) => {
			u += "blankContractStatuses=" + encodeURIComponent("" + e) + "&";
		}), a != null && (u += "addressSearch=" + encodeURIComponent("" + a) + "&"), o != null && (u += "continuationToken=" + encodeURIComponent("" + o) + "&"), s != null && (u += "pageSize=" + encodeURIComponent("" + s) + "&"), c != null && (u += "sortingOption=" + encodeURIComponent("" + c) + "&"), u = u.replace(/[?&]$/, "");
		let d = {
			method: "GET",
			url: u,
			headers: { Accept: "application/json" },
			signal: l
		};
		return this.transformOptions(d).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(u, e, (e) => this.processStaffGetCampaignDashboard(e)));
	}
	processStaffGetCampaignDashboard(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCampaignOverview(e, t) {
		let n = this.baseUrl + "/StaffGetCampaignOverview?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetCampaignOverview(e)));
	}
	processStaffGetCampaignOverview(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractDashboard(e, t, n, r, i, a, o) {
		let s = this.baseUrl + "/StaffGetContractDashboard?";
		e != null && e && e.forEach((e) => {
			s += "agencyIds=" + encodeURIComponent("" + e) + "&";
		}), t != null && t && t.forEach((e) => {
			s += "contractStatuses=" + encodeURIComponent("" + e) + "&";
		}), n != null && n && n.forEach((e) => {
			s += "settlementDateStatuses=" + encodeURIComponent("" + e) + "&";
		}), r != null && r && r.forEach((e) => {
			s += "vendorBankDetailsStatuses=" + encodeURIComponent("" + e) + "&";
		}), i != null && (s += "addressSearch=" + encodeURIComponent("" + i) + "&"), a != null && (s += "sortingOptionContractDashboard=" + encodeURIComponent("" + a) + "&"), s = s.replace(/[?&]$/, "");
		let c = {
			method: "GET",
			url: s,
			headers: { Accept: "application/json" },
			signal: o
		};
		return this.transformOptions(c).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(s, e, (e) => this.processStaffGetContractDashboard(e)));
	}
	processStaffGetContractDashboard(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContract(e, t) {
		let n = this.baseUrl + "/StaffGetContract?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetContract(e)));
	}
	processStaffGetContract(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetContractsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetContractsForCampaign(e)));
	}
	processStaffGetContractsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetDocumentsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetDocumentsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetDocumentsForCampaign(e)));
	}
	processStaffGetDocumentsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetFormConfiguration(e, t) {
		let n = this.baseUrl + "/StaffGetFormConfiguration";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetFormConfiguration(e)));
	}
	processStaffGetFormConfiguration(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetUploadedFileLink(e, t) {
		let n = this.baseUrl + "/StaffGetUploadedFileLink?";
		if (e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		n += "filePath=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "text/plain" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetUploadedFileLink(e)));
	}
	processStaffGetUploadedFileLink(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSaveForm(e, t) {
		let n = this.baseUrl + "/StaffSaveForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffSaveForm(e)));
	}
	processStaffSaveForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSubmitForm(e, t) {
		let n = this.baseUrl + "/StaffSubmitForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffSubmitForm(e)));
	}
	processStaffSubmitForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBlankContractDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetBlankContractDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBlankContractDetailsForCampaign(e)));
	}
	processStaffGetBlankContractDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPropertyDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetPropertyDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPropertyDetailsForCampaign(e)));
	}
	processStaffGetPropertyDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPropertyInformationProgressForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetPropertyInformationProgressForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPropertyInformationProgressForCampaign(e)));
	}
	processStaffGetPropertyInformationProgressForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetTenancyInformationForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetTenancyInformationForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetTenancyInformationForCampaign(e)));
	}
	processStaffGetTenancyInformationForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetVendorDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetVendorDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetVendorDetailsForCampaign(e)));
	}
	processStaffGetVendorDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBlankContractDetailsForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBlankContractDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBlankContractDetailsForCampaign(e)));
	}
	processStaffUpdateBlankContractDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdatePropertyDetailsForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdatePropertyDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdatePropertyDetailsForCampaign(e)));
	}
	processStaffUpdatePropertyDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateTenancyInformationForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateTenancyInformationForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateTenancyInformationForCampaign(e)));
	}
	processStaffUpdateTenancyInformationForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateVendorDetailsForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateVendorDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateVendorDetailsForCampaign(e)));
	}
	processStaffUpdateVendorDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetAgreementDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetAgreementDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetAgreementDetailsForCampaign(e)));
	}
	processStaffGetAgreementDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCommissionInfoForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetCommissionInfoForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetCommissionInfoForCampaign(e)));
	}
	processStaffGetCommissionInfoForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetExternalConjunction(e, t) {
		let n = this.baseUrl + "/StaffGetExternalConjunction?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetExternalConjunction(e)));
	}
	processStaffGetExternalConjunction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetLaunchDateDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetLaunchDateDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetLaunchDateDetailsForCampaign(e)));
	}
	processStaffGetLaunchDateDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPhotosAndMediaDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetPhotosAndMediaDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffGetPhotosAndMediaDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateAgreementDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateAgreementDetailsForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateAgreementDetailsForCampaign(e)));
	}
	processStaffUpdateAgreementDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateCommissionInfoForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateCommissionInfoForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateCommissionInfoForCampaign(e)));
	}
	processStaffUpdateCommissionInfoForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateExternalConjunction(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateExternalConjunction?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateExternalConjunction(e)));
	}
	processStaffUpdateExternalConjunction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateLaunchDateForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateLaunchDateForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateLaunchDateForCampaign(e)));
	}
	processStaffUpdateLaunchDateForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdatePhotosAndMediaDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdatePhotosAndMediaDetailsForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdatePhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffUpdatePhotosAndMediaDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateServiceFeeInfoForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateServiceFeeInfoForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateServiceFeeInfoForCampaign(e)));
	}
	processStaffUpdateServiceFeeInfoForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.And = "And", e.Or = "Or", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.EQ = "EQ", e.NEQ = "NEQ", e.LT = "LT", e.GT = "GT", e.LTEQ = "LTEQ", e.GTEQ = "GTEQ", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.AdditionalDocumentations = "AdditionalDocumentations", e.AddressSearch = "AddressSearch", e.BuyersAgentSearch = "BuyersAgentSearch", e.AgreementDetails = "AgreementDetails", e.BuildingAndPest = "BuildingAndPest", e.VendorBuyerDetails = "VendorBuyerDetails", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.ContractDeposit = "ContractDeposit", e.DepositPayable = "DepositPayable", e.Dropdown = "Dropdown", e.Date = "Date", e.DateTime = "DateTime", e.TextInput = "TextInput", e.Radio = "Radio", e.InfoLabel = "InfoLabel", e.PropertySearch = "PropertySearch", e.SolicitorSearch = "SolicitorSearch", e.ListingAgentSelector = "ListingAgentSelector", e.Commission = "Commission", e.PersonName = "PersonName", e.Checkbox = "Checkbox", e.MarketingPackage = "MarketingPackage", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.ReviewAndSign = "ReviewAndSign", e.AlternateAddressSearch = "AlternateAddressSearch", e.FileUpload = "FileUpload", e.TenantedProperty = "TenantedProperty", e.TypedDocumentUpload = "TypedDocumentUpload", e.POADocumentUpload = "POADocumentUpload", e.TextArea = "TextArea", e.SaleDetails = "SaleDetails", e.LaunchDetails = "LaunchDetails", e.SpecialConditions = "SpecialConditions", e.YesNoQuestion = "YesNoQuestion", e.SettlementDate = "SettlementDate", e.SendForDocuSigning = "SendForDocuSigning", e.SignboardRemoval = "SignboardRemoval", e.MarketingContributions = "MarketingContributions", e.DisplayPrice = "DisplayPrice", e.PriceSpecification = "PriceSpecification", e.Currency = "Currency", e.SubjectToFinance = "SubjectToFinance", e.AdjustmentToCommission = "AdjustmentToCommission", e.ExternalConjunction = "ExternalConjunction", e.PropertyType = "PropertyType", e.VendorDetailsDisplay = "VendorDetailsDisplay", e.ConditionalTextInput = "ConditionalTextInput", e.SecondaryAgentCommissionSplit = "SecondaryAgentCommissionSplit", e.TenancyDetails = "TenancyDetails", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.LegalDescription = "LegalDescription", e.PropertyAttributes = "PropertyAttributes", e.ChattelsIncluded = "ChattelsIncluded", e.RuralParticulars = "RuralParticulars", e.PriceOpinion = "PriceOpinion", e.EditablePdfUpload = "EditablePdfUpload", e.Deposit = "Deposit", e.CoolingOffPeriod = "CoolingOffPeriod", e.Image = "Image", e.Alerts = "Alerts", e.MarketingConfirmation = "MarketingConfirmation", e.MarketingLaunchDetails = "MarketingLaunchDetails", e.SellersDisclosurePreparedBy = "SellersDisclosurePreparedBy", e.BodyCorporate = "BodyCorporate", e.SellersDisclosureUpload = "SellersDisclosureUpload", e.CommunityTitlesScheme = "CommunityTitlesScheme", e.BodyCorporateRecords = "BodyCorporateRecords", e.SurveyPlanUpload = "SurveyPlanUpload", e.IdentityVerificationExports = "IdentityVerificationExports", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Information = "Information", e.Action = "Action", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.HouseAndLand = "HouseAndLand", e.CommunityTitles = "CommunityTitles", e.NewContract2025 = "NewContract2025", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.InPerson = "InPerson", e.Biometric = "Biometric", e.NoPhotoId = "NoPhotoId", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Australia = "Australia", e.NewSouthWales = "NewSouthWales", e.Other = "Other", e.Queensland = "Queensland", e.Victoria = "Victoria", e.NorthernTerritory = "NorthernTerritory", e.SouthAustralia = "SouthAustralia", e.WesternAustralia = "WesternAustralia", e.AustralianCapitalTerritory = "AustralianCapitalTerritory", e.Tasmania = "Tasmania", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Downsizing = "Downsizing", e.Upsizing = "Upsizing", e.Relocating = "Relocating", e.Other = "Other", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.FullTime = "FullTime", e.PartTime = "PartTime", e.Casual = "Casual", e.Unemployed = "Unemployed", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), ne = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), re = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), ie = /* @__PURE__ */ function(e) {
	return e.FullEdit = "FullEdit", e.PartialEdit = "PartialEdit", e.ReadOnly = "ReadOnly", e;
}({}), ae = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), oe = /* @__PURE__ */ function(e) {
	return e.Other = "Other", e.ToBeAdvised = "ToBeAdvised", e;
}({}), se = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), ce = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Email = "Email", e.Phone = "Phone", e.Currency = "Currency", e.TextArea = "TextArea", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.NotTenanted = "NotTenanted", e.TenantedAgencyManaged = "TenantedAgencyManaged", e.TenantedSelfManaged = "TenantedSelfManaged", e.Unknown = "Unknown", e.TenantedAgencyManagedHolidayRental = "TenantedAgencyManagedHolidayRental", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.Weekly = "Weekly", e.Fortnightly = "Fortnightly", e.Monthly = "Monthly", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.NoPool = "NoPool", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.Form36 = "Form36", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.None = "None", e.CompanyManaged = "CompanyManaged", e.SelfManaged = "SelfManaged", e.NonFunctioning = "NonFunctioning", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.On = "On", e.NDaysFrom = "NDaysFrom", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.BusinessDays = "BusinessDays", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.Weeks = "Weeks", e.Months = "Months", e.Years = "Years", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Finance = "Finance", e;
}({}), H = /* @__PURE__ */ function(e) {
	return e.OnDate = "OnDate", e.NdaysFromDate = "NdaysFromDate", e.OnSpecificDate = "OnSpecificDate", e.UponSatisfactionOfSpecialCondition = "UponSatisfactionOfSpecialCondition", e.AdditionalReason = "AdditionalReason", e.NotApplicable = "NotApplicable", e.NotSubjectToFinance = "NotSubjectToFinance", e.Other = "Other", e.AsPerContract = "AsPerContract", e.BuildingAndPestBeingSatisfied = "BuildingAndPestBeingSatisfied", e.FinanceBeingSatisfied = "FinanceBeingSatisfied", e.OnCoolingOffDate = "OnCoolingOffDate", e;
}({}), U = /* @__PURE__ */ function(e) {
	return e.JointTenants = "JointTenants", e.TenantsInCommon = "TenantsInCommon", e.Trustee = "Trustee", e.SoleProprietor = "SoleProprietor", e;
}({}), W = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), G = /* @__PURE__ */ function(e) {
	return e.Initial = "Initial", e.Balance = "Balance", e;
}({}), le = /* @__PURE__ */ function(e) {
	return e.IncludeShorteningOfCoolingOff = "IncludeShorteningOfCoolingOff", e.IncludeWaiverOfCoolingOff = "IncludeWaiverOfCoolingOff", e;
}({}), ue = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), de = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), fe = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), pe = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), me = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), he = /* @__PURE__ */ function(e) {
	return e.Exclusive = "Exclusive", e.Open = "Open", e.Sole = "Sole", e;
}({}), ge = /* @__PURE__ */ function(e) {
	return e.SingleRate = "SingleRate", e.MultiRate = "MultiRate", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.Flat = "Flat", e.Tiered = "Tiered", e.VendorChoice = "VendorChoice", e.Other = "Other", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.Search = "Search", e.Manual = "Manual", e.AttachAsFile = "AttachAsFile", e.NotAvailable = "NotAvailable", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.NoPoolCertificate = "NoPoolCertificate", e;
}({}), be = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), xe = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), Se = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), Ce = /* @__PURE__ */ function(e) {
	return e.FiveDays = "FiveDays", e.TenDays = "TenDays", e.NDays = "NDays", e.NoCoolingOff = "NoCoolingOff", e;
}({}), we = /* @__PURE__ */ function(e) {
	return e.Waived = "Waived", e.Exempt = "Exempt", e;
}({}), Te = /* @__PURE__ */ function(e) {
	return e.PartialDepositPaidUpfront = "PartialDepositPaidUpfront", e.FullDepositPaidUpfront = "FullDepositPaidUpfront", e;
}({}), Ee = /* @__PURE__ */ function(e) {
	return e.SalesAdvice = "SalesAdvice", e.ContractExchange = "ContractExchange", e;
}({}), De = /* @__PURE__ */ function(e) {
	return e.PendingCompliance = "PendingCompliance", e.Current = "Current", e.UnderContract = "UnderContract", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), Oe = /* @__PURE__ */ function(e) {
	return e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e.LaunchDateNotSet = "LaunchDateNotSet", e.OffMarket = "OffMarket", e;
}({}), ke = /* @__PURE__ */ function(e) {
	return e.Paid = "Paid", e.AwaitingFunds = "AwaitingFunds", e;
}({}), Ae = /* @__PURE__ */ function(e) {
	return e.Offline = "Offline", e.Live = "Live", e;
}({}), je = /* @__PURE__ */ function(e) {
	return e.LaunchDateAsc = "LaunchDateAsc", e.LaunchDateDesc = "LaunchDateDesc", e;
}({}), Me = /* @__PURE__ */ function(e) {
	return e.AwaitingExchange = "AwaitingExchange", e.PendingCompliance = "PendingCompliance", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e.Settled = "Settled", e.Terminated = "Terminated", e;
}({}), Ne = /* @__PURE__ */ function(e) {
	return e.SettlementDateSet = "SettlementDateSet", e.NoDateSet = "NoDateSet", e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e;
}({}), Pe = /* @__PURE__ */ function(e) {
	return e.Outstanding = "Outstanding", e.Complete = "Complete", e.Na = "Na", e;
}({}), Fe = /* @__PURE__ */ function(e) {
	return e.SettlementDateAsc = "SettlementDateAsc", e.SettlementDateDesc = "SettlementDateDesc", e;
}({}), Ie = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Le = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), Re = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ze = /* @__PURE__ */ function(e) {
	return e.Restore = "Restore", e.RevertToCurrent = "RevertToCurrent", e.MarkAsUnderContract = "MarkAsUnderContract", e.MarkAsSold = "MarkAsSold", e.Archive = "Archive", e.Withdraw = "Withdraw", e;
}({}), Be = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), Ve = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), He = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), Ue = /* @__PURE__ */ function(e) {
	return e.Archived = "Archived", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), We = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), Ge = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), Ke = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), qe = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), Je = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Ye = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), Xe = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), Ze = /* @__PURE__ */ function(e) {
	return e.RevertToAccepted = "RevertToAccepted", e.RevertToUnconditional = "RevertToUnconditional", e.MarkAsAwaitingExchange = "MarkAsAwaitingExchange", e.MarkAsAccepted = "MarkAsAccepted", e.MarkAsUnconditional = "MarkAsUnconditional", e.MarkSettled = "MarkSettled", e.Terminated = "Terminated", e.Cancelled = "Cancelled", e;
}({}), Qe = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e;
}({}), $e = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e;
}({}), et = /* @__PURE__ */ function(e) {
	return e.RPDataSearch = "RPDataSearch", e.ManualAddress = "ManualAddress", e;
}({}), tt = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), nt = /* @__PURE__ */ function(e) {
	return e.DocuSign = "DocuSign", e.UploadedManually = "UploadedManually", e;
}({}), rt = /* @__PURE__ */ function(e) {
	return e.OffMarket = "OffMarket", e.LaunchScheduled = "LaunchScheduled", e;
}({}), it = /* @__PURE__ */ function(e) {
	return e.None = "None", e.BlankPrepared = "BlankPrepared", e.ContractSubmitted = "ContractSubmitted", e;
}({}), at = /* @__PURE__ */ function(e) {
	return e.AgentPortal = "AgentPortal", e.UploadedManually = "UploadedManually", e;
}({}), ot = /* @__PURE__ */ function(e) {
	return e.None = "None", e.Finance = "Finance", e.BuildingAndPest = "BuildingAndPest", e.BodyCorporate = "BodyCorporate", e.CoolingOff = "CoolingOff", e.SeveralSpecialConditions = "SeveralSpecialConditions", e;
}({}), st = /* @__PURE__ */ function(e) {
	return e.NewContract = "NewContract", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e;
}({}), ct = /* @__PURE__ */ function(e) {
	return e.Standard = "Standard", e.ExceedsTenPercent = "ExceedsTenPercent", e.EarlyRelease = "EarlyRelease", e;
}({}), lt = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), ut = /* @__PURE__ */ function(e) {
	return e.Manual = "Manual", e.DocuSign = "DocuSign", e.Email = "Email", e;
}({}), dt = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), ft = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), pt = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), mt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), ht = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), gt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), _t = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), vt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), yt = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Staff = "Staff", e;
}({}), bt = /* @__PURE__ */ function(e) {
	return e.None = "None", e.ForwardAndBack = "ForwardAndBack", e.BackAndReview = "BackAndReview", e.BackAndSubmit = "BackAndSubmit", e.Forward = "Forward", e;
}({}), xt = /* @__PURE__ */ function(e) {
	return e.Send = "Send", e.GeneratePdf = "GeneratePdf", e;
}({}), St = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Ct = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), wt = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), Tt = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), Et = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), Dt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Ot = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), kt = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), At = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), jt = /* @__PURE__ */ function(e) {
	return e.Complete = "Complete", e.Future = "Future", e.FutureDisabled = "FutureDisabled", e.Invalid = "Invalid", e;
}({}), Mt = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Nt = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), Pt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Ft = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), It = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), Lt = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), Rt = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), zt = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Bt = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Vt = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Ht = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), Ut = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), Wt = /* @__PURE__ */ function(e) {
	return e.Pexa = "Pexa", e.InPerson = "InPerson", e;
}({}), Gt = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Kt = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), qt = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), Jt = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), Yt = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Xt = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), Zt = /* @__PURE__ */ function(e) {
	return e.Pexa = "Pexa", e.InPerson = "InPerson", e;
}({}), Qt = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.NoDepositReceived = "NoDepositReceived", e;
}({}), $t = /* @__PURE__ */ function(e) {
	return e.CoolingOffPeriod = "CoolingOffPeriod", e.FailedFinance = "FailedFinance", e.FailedBuildingAndPest = "FailedBuildingAndPest", e.SpecialConditions = "SpecialConditions", e;
}({}), en = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), tn = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), nn = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), rn = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), an = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), on = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), sn = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Docusign = "Docusign", e;
}({}), cn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), ln = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), un = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), dn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), fn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), pn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), mn = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), hn = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), gn = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), _n = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), vn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), yn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), bn = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), xn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), Sn = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), Cn = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), wn = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), Tn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), En = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), Dn = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), On = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), kn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), An = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), jn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Mn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Nn = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), Pn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Fn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), In = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), Ln = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Rn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), zn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Bn = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Vn = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), Hn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Un = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Wn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Gn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Kn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), qn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), Jn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Yn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Xn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), K = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCampaignsApiException = !0;
	static isCampaignsApiException(e) {
		return e.isCampaignsApiException === !0;
	}
};
function q(e, t, n, r, i) {
	throw i ?? new K(e, t, n, r, null);
}
function J(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var Y = "campaigns";
function Zn(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var X = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), Zn(r);
}, Qn = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[Y] || `${e}/${Y}`;
}, Z = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = Qn(i), u = c, d = X(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(X(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, Q = a({}), $n = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Z(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(Q.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, er = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.constructConditionClauseText(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		constructConditionClauseText: u,
		constructConditionClauseTextPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, tr = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getSpecialConditionBank"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getSpecialConditionBank(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, nr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getSpecialConditionBank"] });
	}, e[0] = t, e[1] = n), n;
}, rr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSpecialConditions",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSpecialConditions(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ir = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSpecialConditions",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ar = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateContractSpecialConditionDueDate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSpecialConditionDueDate: u,
		staffUpdateContractSpecialConditionDueDatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, or = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractSpecialConditions(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSpecialConditions: u,
		staffUpdateContractSpecialConditionsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, sr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async () => a.negotiate(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		negotiate: u,
		negotiatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, cr = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(Q), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"staffSearchForCampaign",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.staffSearchForCampaign(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, lr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"staffSearchForCampaign",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, ur = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async () => a.formsByLocations(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		formsByLocations: u,
		formsByLocationsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, dr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"loadForm",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.loadForm(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, fr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"loadForm",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, pr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.saveForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		saveForm: u,
		saveFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, mr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendForm: u,
		sendFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, hr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.submitForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		submitForm: u,
		submitFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, gr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, _r = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, vr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFile(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFile: u,
		removeFilePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, yr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, documentType: n, contractId: r, filePath: i } = e;
		return a.addOrUpdateDocument(t, n, r, i);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		addOrUpdateDocument: u,
		addOrUpdateDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, br = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.exchangeContract(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		exchangeContract: u,
		exchangeContractPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, xr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.performContractAction(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		performContractAction: u,
		performContractActionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Sr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersAgent", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersAgent(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Cr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersAgent", e] });
	}, e[0] = t, e[1] = n), n;
}, wr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyers(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Tr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyers", e] });
	}, e[0] = t, e[1] = n), n;
}, Er = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersSolicitor", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersSolicitor(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Dr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersSolicitor", e] });
	}, e[0] = t, e[1] = n), n;
}, Or = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDates",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDates(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, kr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDates",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Ar = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDeposits",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDeposits(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, jr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDeposits",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Mr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractEarlyRelease",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractEarlyRelease(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Nr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractEarlyRelease",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Pr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractSettlement",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractSettlement(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Fr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractSettlement",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Ir = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSaleInformation",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSaleInformation(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Lr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSaleInformation",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Rr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffPreviewLinkedDates(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffPreviewLinkedDates: u,
		staffPreviewLinkedDatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, zr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyersAgent(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyersAgent: u,
		staffUpdateBuyersAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Br = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyers(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyers: u,
		staffUpdateBuyersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Vr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyersSolicitor(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyersSolicitor: u,
		staffUpdateBuyersSolicitorPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Hr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractComplianceFields(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractComplianceFields: u,
		staffUpdateContractComplianceFieldsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ur = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractDates(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractDates: u,
		staffUpdateContractDatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Wr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractDeposits(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractDeposits: u,
		staffUpdateContractDepositsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Gr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractEarlyRelease(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractEarlyRelease: u,
		staffUpdateContractEarlyReleasePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Kr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractSettlement(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSettlement: u,
		staffUpdateContractSettlementPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, qr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractTermination(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractTermination: u,
		staffUpdateContractTerminationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Jr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateSaleInformation(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateSaleInformation: u,
		staffUpdateSaleInformationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Yr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.beginCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		beginCampaign: u,
		beginCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Xr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.completeCampaignStep(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		completeCampaignStep: u,
		completeCampaignStepPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Zr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.devCreateContractTestCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		devCreateContractTestCampaign: u,
		devCreateContractTestCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Qr = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getActiveCampaigns"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getActiveCampaigns(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, $r = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getActiveCampaigns"] });
	}, e[0] = t, e[1] = n), n;
}, ei = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getArchivedCampaignsByAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getArchivedCampaignsByAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ti = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAgency"] });
	}, e[0] = t, e[1] = n), n;
}, ni = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ri = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, ii = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.performCampaignAction(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		performCampaignAction: u,
		performCampaignActionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ai = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFormSubmission(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFormSubmission: u,
		removeFormSubmissionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, oi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getArchivedCampaignsByAdmin", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getArchivedCampaignsByAdmin(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, si = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAdmin", e] });
	}, e[0] = t, e[1] = n), n;
}, ci = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaignsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaignsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, li = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaignsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, ui = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setCampaignOwnership(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setCampaignOwnership: u,
		setCampaignOwnershipPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, di = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffBeginCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffBeginCampaign: u,
		staffBeginCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, fi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, pi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, mi = (e, t, n, i, a, s, c, l, d, f) => {
	let p = r(29), m = f === void 0 ? !0 : f, h = o(Q), g;
	p[0] !== s || p[1] !== e || p[2] !== a || p[3] !== t || p[4] !== c || p[5] !== n || p[6] !== i || p[7] !== l || p[8] !== d ? (g = [
		"staffGetCampaignDashboard",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d
	], p[0] = s, p[1] = e, p[2] = a, p[3] = t, p[4] = c, p[5] = n, p[6] = i, p[7] = l, p[8] = d, p[9] = g) : g = p[9];
	let _ = g, v;
	p[10] !== s || p[11] !== e || p[12] !== h || p[13] !== a || p[14] !== t || p[15] !== c || p[16] !== n || p[17] !== i || p[18] !== l || p[19] !== d ? (v = (r) => {
		let { signal: o } = r;
		return h.staffGetCampaignDashboard(e, t, n, i, a, s, c, l, d, o);
	}, p[10] = s, p[11] = e, p[12] = h, p[13] = a, p[14] = t, p[15] = c, p[16] = n, p[17] = i, p[18] = l, p[19] = d, p[20] = v) : v = p[20];
	let y = m && !!h, b;
	p[21] !== _ || p[22] !== v || p[23] !== y ? (b = {
		queryKey: _,
		queryFn: v,
		enabled: y
	}, p[21] = _, p[22] = v, p[23] = y, p[24] = b) : b = p[24];
	let { data: x, isPending: S, isError: C } = u(b), w;
	return p[25] !== x || p[26] !== C || p[27] !== S ? (w = {
		data: x,
		isPending: S,
		isError: C
	}, p[25] = x, p[26] = C, p[27] = S, p[28] = w) : w = p[28], w;
}, hi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetCampaignDashboard",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l
		] });
	}, e[0] = t, e[1] = n), n;
}, gi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaignOverview", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaignOverview(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, _i = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaignOverview", e] });
	}, e[0] = t, e[1] = n), n;
}, vi = (e, t, n, i, a, s, c) => {
	let l = r(23), d = c === void 0 ? !0 : c, f = o(Q), p;
	l[0] !== a || l[1] !== e || l[2] !== t || l[3] !== n || l[4] !== s || l[5] !== i ? (p = [
		"staffGetContractDashboard",
		e,
		t,
		n,
		i,
		a,
		s
	], l[0] = a, l[1] = e, l[2] = t, l[3] = n, l[4] = s, l[5] = i, l[6] = p) : p = l[6];
	let m = p, h;
	l[7] !== a || l[8] !== e || l[9] !== f || l[10] !== t || l[11] !== n || l[12] !== s || l[13] !== i ? (h = (r) => {
		let { signal: o } = r;
		return f.staffGetContractDashboard(e, t, n, i, a, s, o);
	}, l[7] = a, l[8] = e, l[9] = f, l[10] = t, l[11] = n, l[12] = s, l[13] = i, l[14] = h) : h = l[14];
	let g = d && !!f, _;
	l[15] !== m || l[16] !== h || l[17] !== g ? (_ = {
		queryKey: m,
		queryFn: h,
		enabled: g
	}, l[15] = m, l[16] = h, l[17] = g, l[18] = _) : _ = l[18];
	let { data: v, isPending: y, isError: b } = u(_), x;
	return l[19] !== v || l[20] !== b || l[21] !== y ? (x = {
		data: v,
		isPending: y,
		isError: b
	}, l[19] = v, l[20] = b, l[21] = y, l[22] = x) : x = l[22], x;
}, yi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDashboard",
			e,
			n,
			r,
			i,
			a,
			o
		] });
	}, e[0] = t, e[1] = n), n;
}, bi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContract", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContract(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, xi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContract", e] });
	}, e[0] = t, e[1] = n), n;
}, Si = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContractsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContractsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ci = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContractsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, wi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetDocumentsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetDocumentsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ti = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetDocumentsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ei = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffGetFormConfiguration(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffGetFormConfiguration: u,
		staffGetFormConfigurationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Di = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Oi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, ki = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSaveForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSaveForm: u,
		staffSaveFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ai = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSubmitForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSubmitForm: u,
		staffSubmitFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ji = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBlankContractDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBlankContractDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Mi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBlankContractDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ni = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Pi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Fi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyInformationProgressForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyInformationProgressForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ii = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyInformationProgressForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Li = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetTenancyInformationForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetTenancyInformationForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ri = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetTenancyInformationForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, $ = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetVendorDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetVendorDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, zi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetVendorDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Bi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateBlankContractDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBlankContractDetailsForCampaign: u,
		staffUpdateBlankContractDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Vi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdatePropertyDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdatePropertyDetailsForCampaign: u,
		staffUpdatePropertyDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Hi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateTenancyInformationForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateTenancyInformationForCampaign: u,
		staffUpdateTenancyInformationForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ui = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateVendorDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateVendorDetailsForCampaign: u,
		staffUpdateVendorDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Wi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgreementDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgreementDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Gi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgreementDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ki = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCommissionInfoForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCommissionInfoForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, qi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCommissionInfoForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ji = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetExternalConjunction", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetExternalConjunction(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Yi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetExternalConjunction", e] });
	}, e[0] = t, e[1] = n), n;
}, Xi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetLaunchDateDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetLaunchDateDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Zi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetLaunchDateDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Qi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPhotosAndMediaDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPhotosAndMediaDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, $i = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPhotosAndMediaDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, ea = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateAgreementDetailsForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateAgreementDetailsForCampaign: u,
		staffUpdateAgreementDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ta = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateCommissionInfoForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateCommissionInfoForCampaign: u,
		staffUpdateCommissionInfoForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, na = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateExternalConjunction(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateExternalConjunction: u,
		staffUpdateExternalConjunctionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ra = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateLaunchDateForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateLaunchDateForCampaign: u,
		staffUpdateLaunchDateForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ia = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdatePhotosAndMediaDetailsForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdatePhotosAndMediaDetailsForCampaign: u,
		staffUpdatePhotosAndMediaDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, aa = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateServiceFeeInfoForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateServiceFeeInfoForCampaign: u,
		staffUpdateServiceFeeInfoForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { gn as AddressSearchStateToSearch, fe as AdjustmentCommissionType, In as AdjustmentToCommissionCondition, he as AgreementType, g as AlertType, p as AndOr, ce as AustralianState, Le as BasicCampaignDetailsModelStage, Ie as BasicCampaignDetailsModelState, Re as BeginCampaignState, Ae as BlankContractStatuses, I as BodyCorporateType, E as BuiltOnOrVacantLandType, ze as CampaignActionRequestCampaignAction, He as CampaignAdminModelMarketingStatus, Be as CampaignAdminModelStage, Ve as CampaignAdminModelState, Ue as CampaignCompletionStateCompletionType, We as CampaignDashboardLaunchStatus, Ge as CampaignDashboardRowMarketingStatus, Je as CampaignDetailModelBlankSalesContractStatus, qe as CampaignDetailModelStage, Ke as CampaignDetailModelState, Ye as CampaignSearchResultStage, De as CampaignStatuses, Q as CampaignsApiContext, K as CampaignsApiException, $n as CampaignsApiProvider, f as CampaignsClient, Y as CampaignsRoute, A as Chattel, wn as Chattels, Xe as CommissionDetailsChangeInfoChangeType, _e as CommissionTypes, On as CommunityTitlesSchemeDocumentType, ve as ComparativeType, H as Condition, V as ConditionType, j as ConditionalTextInputType, Ze as ContractActionRequestContractAction, Ee as ContractCompletionType, L as ContractConditionType, Qe as ContractDashboardRowVendorBankDetailsStatus, $e as ContractDatesConditionConfigContractDateType, Me as ContractStatuses, _ as ContractType, le as CoolingOffCondition, Ce as CoolingOffType, k as CustomPdfScript, z as DayType, R as DepositPayable, Te as DepositPaymentType, G as DepositType, nt as DevCreateContractTestCampaignRequestAgreementSource, it as DevCreateContractTestCampaignRequestContract, ot as DevCreateContractTestCampaignRequestContractConditions, at as DevCreateContractTestCampaignRequestContractCreationSource, st as DevCreateContractTestCampaignRequestContractStage, et as DevCreateContractTestCampaignRequestCreateFrom, ct as DevCreateContractTestCampaignRequestDepositProfile, rt as DevCreateContractTestCampaignRequestListingLaunch, tt as DevCreateContractTestCampaignRequestState, Nn as DocuSignInfoCondition, te as DocumentTypes, lt as EarlyReleaseOfDepositDestinationOfTransfer, ie as EditScope, Cn as EditablePdfButtonPdfFieldType, O as EditablePdfButtonType, Sn as EditablePdfUploadCustomScript, xn as EditablePdfUploadDocumentType, h as ElementType, ee as EmploymentStatus, dt as EnvelopeSubmissionModelStatus, ut as EnvelopeSubmissionModelType, ft as EnvelopeSubmissionRecipientStatus, pt as ExternalConjunctionConjunctionFeeType, _n as FileUploadDocumentType, pe as FlatCommissionType, gt as FormConfigurationRequestFormType, yt as FormDetailsFlow, _t as FormDetailsState, vt as FormDetailsType, bt as FormPageActionButtonType, xt as FormPageSubmitType, ht as FormState, St as FormSubmissionRequestFormType, Ct as FormSubmissionRequestState, mt as FormType, b as IdentityDocument, wt as IdentityVerificationDocumentSighted, se as IdentityVerificationExportsAggregateStatus, hn as IdentityVerificationExportsModelAggregateStatus, Et as IdentityVerificationProofOfOwnershipDocument, Dt as InProgressFormModelFormType, v as IsoDayOfWeek, D as LandAreaType, Ot as LaunchDateDetailsStatus, Se as LaunchDateStatus, Oe as LaunchDateStatuses, kt as LaunchDetailsStatus, C as LegalOwnershipDocument, At as LinkedDateImpactSourceDateType, ke as MarketingStatuses, we as NoCoolingOffReason, Jn as NswContractRequestModelDisplaySalePriceOnceSold, Yn as NswContractSubmissionModelDisplaySalePriceOnceSold, Xn as NswListingGeneratorModelVendorWaivingCoolingOffPeriod, m as Operator, En as OwnerBuilderDeclarationCustomScript, Tn as OwnerBuilderDeclarationDocumentType, U as OwnershipStructure, jt as PageStatusStatus, x as PlaceOfIssue, ye as PoolDocumentationType, F as PoolSafetyFileType, Mn as QldContractRequestModelAcquiringLandForTaxPurpose, jn as QldContractRequestModelDisplayTenantDetailsOnContract, An as QldContractRequestModelIncludeBuyerDetailsOnContract, kn as QldContractRequestModelIncludeVendorDetailsOnContract, Pn as QldContractSubmissionModelDisplaySalePriceOnceSold, Un as QldListingSubmissionModelApprovedSafetySwitchInstalled, Wn as QldListingSubmissionModelCompliesWithSmokeAlarmLegislation, Gn as QldListingSubmissionModelGstIsPaymentRequired, Hn as QldListingSubmissionModelIncludeVendorDetailsOnContract, Kn as QldListingSubmissionModelNeighbourhoodDisputes, un as QueenslandBlankContractModelApprovedSafetySwitchInstalled, dn as QueenslandBlankContractModelCompliesWithSmokeAlarmLegislation, fn as QueenslandBlankContractModelGstIsPaymentRequired, ln as QueenslandBlankContractModelIncludeVendorDetailsOnContract, pn as QueenslandBlankContractModelNeighbourhoodDisputes, Ln as QueenslandListingGeneratorModelApprovedSafetySwitchInstalled, Rn as QueenslandListingGeneratorModelCompliesWithSmokeAlarmLegislation, zn as QueenslandListingGeneratorModelNeighbourhoodDisputes, w as ReasonForTransaction, Mt as RenderedSpecialConditionConditionType, P as RentPeriod, T as RuralType, Bn as SaleDetailsState, de as SaleType, S as SecondaryIdentityDocument, Tt as SecondaryIdentityDocuments, be as SellersDisclosurePreparedBy, Vn as SellersDisclosurePreparedByModelPreparedBy, bn as SellersDisclosureUploadCustomScript, yn as SellersDisclosureUploadDocumentType, ue as SendForDocuSigningType, Pt as SendFormSubmissionModelFormType, Ft as SendFormSubmissionModelState, It as ServiceFeeDetailsChangeInfoChangeType, Ne as SettlementDateStatuses, Lt as SignboardRemovalRemovalType, me as SignboardRemovalType, Nt as SigningOrderGroups, oe as SolicitorType, je as SortingOption, Fe as SortingOptionContractDashboard, Rt as SpecialConditionBankTemplateConditionType, zt as SpecialConditionDataConditionType, Bt as StaffBeginCampaignRequestState, Vt as StaffGetBlankContractDetailsForCampaignResponseBlankSalesContractStatus, Ht as StaffGetCampaignOverviewResponseVendorCommunicationPreference, Ut as StaffGetCommissionInfoForCampaignModelPartnershipLevel, Wt as StaffGetContractSettlementResponseSettlementType, Gt as StaffGetSaleInformationResponseSaleMethod, qt as StaffGetSaleInformationResponseUnconditionalDisplayAs, Kt as StaffGetSaleInformationResponseUnderOfferDisplayAs, Jt as StaffPreviewLinkedDatesRequestSourceDateType, Yt as StaffUpdateBlankContractDetailsForCampaignRequestBlankSalesContractStatus, Xt as StaffUpdateCommissionInfoForCampaignRequestChangeType, Zt as StaffUpdateContractSettlementRequestSettlementType, $t as StaffUpdateContractTerminationRequestContractTerminationReasons, Qt as StaffUpdateContractTerminationRequestDepositEntitlement, en as StaffUpdateLaunchDateForCampaignRequestStatus, tn as StaffUpdateSaleInformationRequestSaleMethod, rn as StaffUpdateSaleInformationRequestUnconditionalDisplayAs, nn as StaffUpdateSaleInformationRequestUnderOfferDisplayAs, an as StaffUpdateServiceFeeInfoForCampaignRequestChangeType, ne as StakeholderType, vn as SurveyPlanUploadDocumentType, Dn as TenancyModelTerm, N as TenancyTerm, M as TenancyType, ge as TieredSystemType, B as TimeUnit, Fn as TypedFormDocumentModelDocumentType, on as UploadedDocumentDocumentType, cn as UploadedDocumentInfoDocumentType, sn as UploadedDocumentInfoSigningMethod, qn as UploadedPOADocumentModelDocumentType, W as ValueType, Pe as VendorBankDetailsStatuses, re as VendorBuyerType, mn as VendorBuyerTypes, xe as VendorCommPreference, y as VerificationMethod, ae as YesNoQuestion, yr as useAddOrUpdateDocument, Yr as useBeginCampaign, Z as useCampaignsClientContext, Xr as useCompleteCampaignStep, er as useConstructConditionClauseText, Zr as useDevCreateContractTestCampaign, br as useExchangeContract, ur as useFormsByLocations, Qr as useGetActiveCampaigns, oi as useGetArchivedCampaignsByAdmin, ei as useGetArchivedCampaignsByAgency, ni as useGetCampaign, ci as useGetCampaignsForAgency, tr as useGetSpecialConditionBank, gr as useGetUploadedFileLink, $r as useInvalidateUseGetActiveCampaigns, si as useInvalidateUseGetArchivedCampaignsByAdmin, ti as useInvalidateUseGetArchivedCampaignsByAgency, ri as useInvalidateUseGetCampaign, li as useInvalidateUseGetCampaignsForAgency, nr as useInvalidateUseGetSpecialConditionBank, _r as useInvalidateUseGetUploadedFileLink, fr as useInvalidateUseLoadForm, Gi as useInvalidateUseStaffGetAgreementDetailsForCampaign, Mi as useInvalidateUseStaffGetBlankContractDetailsForCampaign, Tr as useInvalidateUseStaffGetBuyers, Cr as useInvalidateUseStaffGetBuyersAgent, Dr as useInvalidateUseStaffGetBuyersSolicitor, pi as useInvalidateUseStaffGetCampaign, hi as useInvalidateUseStaffGetCampaignDashboard, _i as useInvalidateUseStaffGetCampaignOverview, qi as useInvalidateUseStaffGetCommissionInfoForCampaign, xi as useInvalidateUseStaffGetContract, yi as useInvalidateUseStaffGetContractDashboard, kr as useInvalidateUseStaffGetContractDates, jr as useInvalidateUseStaffGetContractDeposits, Nr as useInvalidateUseStaffGetContractEarlyRelease, Fr as useInvalidateUseStaffGetContractSettlement, Ci as useInvalidateUseStaffGetContractsForCampaign, Ti as useInvalidateUseStaffGetDocumentsForCampaign, Yi as useInvalidateUseStaffGetExternalConjunction, Zi as useInvalidateUseStaffGetLaunchDateDetailsForCampaign, $i as useInvalidateUseStaffGetPhotosAndMediaDetailsForCampaign, Pi as useInvalidateUseStaffGetPropertyDetailsForCampaign, Ii as useInvalidateUseStaffGetPropertyInformationProgressForCampaign, Lr as useInvalidateUseStaffGetSaleInformation, ir as useInvalidateUseStaffGetSpecialConditions, Ri as useInvalidateUseStaffGetTenancyInformationForCampaign, Oi as useInvalidateUseStaffGetUploadedFileLink, zi as useInvalidateUseStaffGetVendorDetailsForCampaign, lr as useInvalidateUseStaffSearchForCampaign, dr as useLoadForm, sr as useNegotiate, ii as usePerformCampaignAction, xr as usePerformContractAction, vr as useRemoveFile, ai as useRemoveFormSubmission, pr as useSaveForm, mr as useSendForm, ui as useSetCampaignOwnership, di as useStaffBeginCampaign, Wi as useStaffGetAgreementDetailsForCampaign, ji as useStaffGetBlankContractDetailsForCampaign, wr as useStaffGetBuyers, Sr as useStaffGetBuyersAgent, Er as useStaffGetBuyersSolicitor, fi as useStaffGetCampaign, mi as useStaffGetCampaignDashboard, gi as useStaffGetCampaignOverview, Ki as useStaffGetCommissionInfoForCampaign, bi as useStaffGetContract, vi as useStaffGetContractDashboard, Or as useStaffGetContractDates, Ar as useStaffGetContractDeposits, Mr as useStaffGetContractEarlyRelease, Pr as useStaffGetContractSettlement, Si as useStaffGetContractsForCampaign, wi as useStaffGetDocumentsForCampaign, Ji as useStaffGetExternalConjunction, Ei as useStaffGetFormConfiguration, Xi as useStaffGetLaunchDateDetailsForCampaign, Qi as useStaffGetPhotosAndMediaDetailsForCampaign, Ni as useStaffGetPropertyDetailsForCampaign, Fi as useStaffGetPropertyInformationProgressForCampaign, Ir as useStaffGetSaleInformation, rr as useStaffGetSpecialConditions, Li as useStaffGetTenancyInformationForCampaign, Di as useStaffGetUploadedFileLink, $ as useStaffGetVendorDetailsForCampaign, Rr as useStaffPreviewLinkedDates, ki as useStaffSaveForm, cr as useStaffSearchForCampaign, Ai as useStaffSubmitForm, ea as useStaffUpdateAgreementDetailsForCampaign, Bi as useStaffUpdateBlankContractDetailsForCampaign, Br as useStaffUpdateBuyers, zr as useStaffUpdateBuyersAgent, Vr as useStaffUpdateBuyersSolicitor, ta as useStaffUpdateCommissionInfoForCampaign, Hr as useStaffUpdateContractComplianceFields, Ur as useStaffUpdateContractDates, Wr as useStaffUpdateContractDeposits, Gr as useStaffUpdateContractEarlyRelease, Kr as useStaffUpdateContractSettlement, ar as useStaffUpdateContractSpecialConditionDueDate, or as useStaffUpdateContractSpecialConditions, qr as useStaffUpdateContractTermination, na as useStaffUpdateExternalConjunction, ra as useStaffUpdateLaunchDateForCampaign, ia as useStaffUpdatePhotosAndMediaDetailsForCampaign, Vi as useStaffUpdatePropertyDetailsForCampaign, Jr as useStaffUpdateSaleInformation, aa as useStaffUpdateServiceFeeInfoForCampaign, Hi as useStaffUpdateTenancyInformationForCampaign, Ui as useStaffUpdateVendorDetailsForCampaign, hr as useSubmitForm };
